import React from 'react';
import './YoutubeAuthModal.scss';

const toConnectAccounts = () => window.location.assign('/connect-accounts');

const YoutubeAuthModal = ({ onClose }) => {
  return (
    <div className="youtube-auth-modal-overlay">
      <div className="youtube-auth-modal">
        <div className="modal-close" onClick={onClose}>
          <svg viewBox="0 0 24 24">
            <path d="M18 6L6 18M6 6l12 12" stroke="#99969C" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>
        <div className="modal-header">
          <div className="red-circle">
            <span className="red-x">!</span>
          </div>
          <div className="auth-title">Connect YouTube</div>
        </div>
        <div className="modal-body">
          You need to connect your YouTube account to participate in this secondary creation quest
        </div>
        <div className="modal-footer">
          <button className="retry-button" onClick={toConnectAccounts}>Connect YouTube</button>
        </div>
      </div>
    </div>
  );
};

export default YoutubeAuthModal;
